var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCommentGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1efxqdgx8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.67 13.126a.5.5 0 0 1 .065-.8h0-.001l.009-.005.048-.034a2.87 2.87 0 0 0 .192-.155 4.12 4.12 0 0 0 .613-.676c.446-.614.904-1.575.904-2.956A5.5 5.5 0 1 0 8 14h4.403a.093.093 0 0 0 .059-.016.106.106 0 0 0 .035-.049.107.107 0 0 0 .005-.06.093.093 0 0 0-.033-.05l-.798-.699z",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.7,
    transform: "matrix(-1 0 0 1 5.6 8.7)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.7,
    transform: "matrix(-1 0 0 1 8 8.7)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.7,
    transform: "matrix(-1 0 0 1 10.4 8.7)",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1efxqdgx8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCommentGray);
export default __webpack_public_path__ + "static/media/new_comment_gray.eac0936abd164c046d65f57efdffc32b.svg";
export { ForwardRef as ReactComponent };